import { Alert } from '@festina-life/ui/feedback'
import { Stack, typographyStyles } from '@festina-life/ui/structure'
import cx from 'classnames'

import { useFormatWarnings } from '../../../hooks/useFormatWarnings'
import type { CodedActionWarning } from '../../commandActions/types'
import type { SearchableItemGroup } from './types'
import { useCommandPaletteLocalStorage } from './useCommandPaletteLocalStorage'

type Props = {
  warnings: CodedActionWarning[] | undefined
  isAvailable: boolean
  group: SearchableItemGroup
  hasNestedChildren: boolean
}

export const OptionWarnings = ({
  warnings,
  isAvailable,
  group,
  hasNestedChildren,
}: Props) => {
  const [favourites] = useCommandPaletteLocalStorage()
  const formattedWarnings = useFormatWarnings(warnings ?? [])
  const shouldHideWarnings =
    favourites[group].shouldHideWarnings && hasNestedChildren

  return warnings?.length && !shouldHideWarnings ? (
    <Alert
      severity="warning"
      variant="mini"
      className={cx(!isAvailable && 'opacity-30 cursor-not-allowed')}
    >
      <Stack
        as="ul"
        className={cx(
          'flex-col',
          typographyStyles({ size: 'sm', intensity: 'secondary' }),
        )}
      >
        {formattedWarnings?.map((warning) => (
          <li key={warning}>{warning}</li>
        ))}
      </Stack>
    </Alert>
  ) : null
}
